import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "link", "form"]

  connect() {
    if (document.getElementsByClassName("invalid-feedback").length > 0) {
      this.formTarget.classList.toggle("d-none")
    }

    if (document.getElementById("promotion")) {
      this.linkTarget.classList.toggle("d-none")
    }
  }

  togglePromotionForm() {
    this.formTarget.classList.toggle("d-none")
  }

  submit() {
    console.log(this.formTarget);
    this.element.requestSubmit()
  }
}
